import { render } from "./TempWidgetExtruder.vue?vue&type=template&id=06036451&scoped=true"
import script from "./TempWidgetExtruder.vue?vue&type=script&lang=js"
export * from "./TempWidgetExtruder.vue?vue&type=script&lang=js"

import "./TempWidgetExtruder.vue?vue&type=style&index=0&id=06036451&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06036451"

export default script